module.exports = __webpack_public_path__ + "img/leftArrow.218a4b75.svg";